import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from '@bart.sk-eshop/react-i18n';

interface GoogleReviewOverallProps {
  reviewOverallData: {
    google_review_rating: number;
    google_review_rating_count: number;
  };
  googlePlaceId: string;
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  /* White card — the page background behind is grey. */
  background-color: ${({ theme }) => theme.color.white};
  padding: 24px;
  flex-direction: column;

  ${({ theme }) => theme.media('sm')} {
    flex-direction: row;
  }
`;

const LeftPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
`;

const RightPart = styled.div`
  display: inline-flex;
  position: relative;
  max-width: 100%;

  margin-top: ${rem(20)};

  ${({ theme }) => theme.media('sm')} {
    margin-top: 0;
  }
`;

const LeftUpPart = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const LeftDownPart = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;

  justify-content: center;

  ${({ theme }) => theme.media('sm')} {
    justify-content: left;
  }
`;

const GoogleLogo = styled.img`
  height: ${rem(30)};
`;

const ReviewText = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 26px;
  color: rgb(17, 17, 17);
  margin-left: ${rem(10)};
`;

const RatingValueText = styled.div`
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  color: rgb(17, 17, 17);
  word-break: normal !important;
`;

const StarsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StarIcon = styled.svg`
  width: 18px;
  height: 18px;
`;

const CountWrapper = styled.div``;

const ButtonWrapper = styled.div`
  display: inline-flex;
  position: relative;
  max-width: 100%;
`;

const ReviewButton = styled.a`
  border-radius: 24px;
  border-color: rgba(0, 0, 0, 0);
  line-height: 1.32;
  color: rgb(255, 255, 255);
  padding: 0px;
  font-family: inherit;
  font-weight: bold;
  font-size: 14px;
  background-color: rgb(25, 123, 255);
  text-transform: none;
  border-width: 2px;
  padding: ${rem(10)};
`;

export const GoogleReviewOverall = ({
  reviewOverallData,
  googlePlaceId,
}: GoogleReviewOverallProps) => {
  return (
    <Wrapper>
      <LeftPart>
        <LeftUpPart>
          <GoogleLogo src="/images/icons/google-full.png" />
          <ReviewText> {__('Recenzie zákazníkov predajne')} </ReviewText>
        </LeftUpPart>
        <LeftDownPart>
          <RatingValueText>
            {' '}
            {reviewOverallData.google_review_rating}{' '}
          </RatingValueText>
          <StarsWrapper>
            {Array.from({ length: 5 }, (_, i) => {
              const fillPercentage =
                Math.max(
                  0,
                  Math.min(1, reviewOverallData.google_review_rating - i),
                ) * 100;
              const gradientId = `starGradient-${i}`;

              return (
                <StarIcon
                  key={i}
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <defs>
                    <linearGradient id={gradientId}>
                      <stop offset={`${fillPercentage}%`} stopColor="#fbbc04" />
                      <stop offset={`${fillPercentage}%`} stopColor="#e0e0e0" />
                    </linearGradient>
                  </defs>
                  <path
                    d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2
                            9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                    fill={`url(#${gradientId})`}
                  />
                </StarIcon>
              );
            })}
          </StarsWrapper>
          <CountWrapper>
            {`(${reviewOverallData.google_review_rating_count})`}
          </CountWrapper>
        </LeftDownPart>
      </LeftPart>
      <RightPart>
        <ButtonWrapper>
          <ReviewButton
            href={`https://search.google.com/local/writereview?placeid=${googlePlaceId}`}
            target="_blank"
          >
            {__('Hodnotiť na google')}
          </ReviewButton>
        </ButtonWrapper>
      </RightPart>
    </Wrapper>
  );
};
